import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';

import Modal from '../Modal';
import HingeFadeInFromTop from '../../transitions/HingeFadeInFromTop';

import { sendArticleFeedbackComment } from '../../utils/api';

import styles from './FeedbackModal.module.scss';

const FeedbackModal = ({ feedbackId, visible, toggleVisible }) => {
    const { t } = useTranslation('common');
    const [modalContentVisible, setModalContentVisible] = useState(false);
    const [feedbackComment, setFeedbackComment] = useState('');

    const handleChange = (e) => setFeedbackComment(e.target.value);

    const handleSubmit = (e) => {
        e.preventDefault();
        sendArticleFeedbackComment(feedbackId, feedbackComment);
        toggleVisible();
    };

    // trigger hinge in animation of modal content
    useEffect(() => {
        setModalContentVisible(visible);
    }, [visible]);

    return (
        <div className={styles['FeedbackModal']}>
            <Modal open={visible} handleClose={toggleVisible}>
                <div>
                    <HingeFadeInFromTop visible={modalContentVisible}>
                        <form className={styles['FeedbackModal__Content']}>
                            <label
                                className={styles['FeedbackModal__Title']}
                                htmlFor="comment">
                                {t('feedbackmodal.thanks')}
                            </label>
                            <textarea
                                name="comment"
                                className={styles['FeedbackModal__Textarea']}
                                placeholder={t('feedbackmodal.placeholder')}
                                value={feedbackComment}
                                onChange={handleChange}
                            />
                            <button
                                className={
                                    styles['FeedbackModal__SubmitButton']
                                }
                                onClick={handleSubmit}>
                                {t('feedbackmodal.submit')}
                            </button>
                        </form>
                    </HingeFadeInFromTop>
                </div>
            </Modal>
        </div>
    );
};

FeedbackModal.propTypes = {
    feedbackId: PropTypes.number,
    visible: PropTypes.bool,
    toggleVisible: PropTypes.func,
};

FeedbackModal.defaultProps = {
    visible: false,
};

export default FeedbackModal;
